import { AuxIcon } from "@blk/aladdin-react-components-es";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { requestAsync } from "redux-query";
import { getGetExportDataExcelHistoryDocument } from "../insHistoryDataExportGrid.requests";
export const InsDownloadIconColumn = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const onDownloadColumnClick = (id) => {
        setIsLoading(true);
        const downloadRequest = getGetExportDataExcelHistoryDocument(id);
        const action = dispatch(requestAsync(downloadRequest));
        if (action instanceof Promise) {
            action.then(() => {
                setIsLoading(false);
            });
        }
    };
    const onClick = () => onDownloadColumnClick(props.id);
    return React.createElement("div", { style: { margin: "0px 14px" } },
        React.createElement(AuxIcon, { slot: "target", type: isLoading ? "loading" : "download", onClick: onClick }));
};
